<template>
    <header v-bind:class="{ 'scrolled' : scrolled }" v-scroll="handleScroll">
        <slot></slot>
    </header>
</template>

<script>
import Scroll from '../directives/Scroll'

export default {
    name: 'SiteHeader',
    directives: {
        Scroll
    },
    data() {
        return {
            scrolled: false
        }
    },
    methods: {
        handleScroll() {
            this.scrolled = window.pageYOffset > 10;
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/js/components/SiteHeader.vue